import React, { useMemo, useState, useEffect, memo } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import { IconButton, Tooltip } from '@material-ui/core';
import { DataGrid, esES } from '@mui/x-data-grid';
import { Dialpad } from '@material-ui/icons';
// WService
import { wsFindBy, wsPost } from 'services/WService';
import moment from 'moment';

const columns = [
  {
    field: 'num',
    width: 10,
    align: 'right',
    headerName: '#',
    disableColumnMenu: 100,
    hideable: false,
    sortable: false,
  },
  {
    field: 'CardName',
    width: 250,
    headerName: 'Cliente',
    hideable: false,
    sortable: false,
  },
  {
    field: 'zone_code',
    width: 70,
    headerName: 'Zona',
    hideable: false,
    sortable: false,
  },
  {
    field: 'DocSubDescription',
    width: 100,
    headerName: 'T.Doc Sun.',
    hideable: false,
    sortable: false,
  },
  { field: 'U_SYP_MDSD', width: 100, headerName: 'Serie Doc.', hideable: false, sortable: false },
  { field: 'U_SYP_MDCD', width: 100, headerName: 'Corr. Sun.', hideable: false, sortable: false },
  { field: 'DocNum', width: 100, headerName: 'Num. SAP', hideable: false, sortable: false },
  {
    field: 'DocStatus',
    width: 100,
    headerName: 'Esta Doc.',
    disableColumnMenu: 100,
    hideable: false,
    sortable: false,
  },
  {
    field: 'ImportEnt',
    width: 75,
    headerName: 'HR',
    disableColumnMenu: 100,
    hideable: false,
    sortable: false,
  },
  {
    field: 'sheet_distribution_state',
    width: 100,
    headerName: 'Estado HR',
    disableColumnMenu: 100,
    hideable: false,
    sortable: false,
  },
  { field: 'TaxDate', width: 100, headerName: 'Fec. Doc.', hideable: false, sortable: false },
  { field: 'DocDueDate', width: 100, headerName: 'Fec. Vto.', hideable: false, sortable: false },
  { field: 'backDay', width: 100, headerName: 'Dias atrás', hideable: false, sortable: false },
  {
    field: 'DiscPrcnt',
    width: 70,
    align: 'right',
    headerName: '%Dsct.',
    hideable: false,
    sortable: false,
  },
  {
    field: 'DocTotal',
    width: 100,
    align: 'right',
    headerName: 'Total Doc.',
    hideable: false,
    sortable: false,
  },
  {
    field: 'PaidToDate',
    width: 100,
    align: 'right',
    headerName: 'Pagado',
    hideable: false,
    sortable: false,
  },
  {
    field: 'Saldo',
    width: 100,
    align: 'right',
    headerName: 'Saldo',
    hideable: false,
    sortable: false,
  },
  {
    field: 'creditNotes',
    width: 100,
    align: 'right',
    headerName: 'Mto. NC',
    sortable: false,
    type: 'number',
    disableColumnMenu: true,
  },
  {
    field: 'totalPaid',
    width: 150,
    align: 'right',
    type: 'number',
    editable: true,
    headerName: 'Pago T.',
    valueSetter: (params) => {
      params.row.totalPaid = parseFloat(params.value).toFixed(2);
      return params.row;
    },
  },
];

function PaymentDocuments(props) {
  const { setDocuments } = props;

  const { setTotalAmount, zoneId } = props;
  const { businessPartner, showNotify } = props;

  const { importedData = [], isImportMode = false } = props;
  const [loading, setLoading] = useState(false);

  const [aviableDocuments, setAviableDocuments] = useState([]);
  const [totalPay, setTotalPay] = useState(0);
  const [handlePay, setHandlePay] = useState(0);
  const [selectionModel, setSelectionModel] = useState([]);
  const [selectionIds, setSelectionIds] = useState([]);

  const dataGridColumns = useMemo(() => {
    let newColumns = [...columns];
    let totalPaidIndex = newColumns.findIndex((column) => column.field === 'totalPaid');
    newColumns[totalPaidIndex].renderCell = renderTotalPaidCell;
    return newColumns;
  }, []);

  const aviableDocumentsMapped = useMemo(() => {
    return aviableDocuments.map((item, i) => {

      let hrState = '';
      switch (item.sheet_distribution_state) {
        case 'W':
          hrState = 'Reparto(W)';
          break;
        case '1':
          hrState = 'Liq Mercadería(1)';
          break;
        case '2':
          hrState = 'Liq Mercadería+(2)';
          break;
        case '3':
          hrState = 'Liq Documento(3)';
          break;
        case '4':
          hrState = 'Liq Documento+(4)';
          break;
        case 'L':
          hrState = 'Liq HR(L)';
          break;
        case '5':
          hrState = 'Cerrado(5)';
          break;
      }

      return {
        id: generateId(item),
        CardName: item.CardName,
        zone_code: item.zone_code,
        DocEntry: item.DocEntry,
        ObjType: item.ObjType,
        num: i + 1,
        DocSubDescription: item.DocSubDescription,
        U_SYP_MDSD: item.U_SYP_MDSD || item.U_SYP_MDSO,
        U_SYP_MDCD: item.U_SYP_MDCD || item.U_SYP_MDCO,
        DocNum: item.DocNum,
        DocStatus: item.DocStatus === 'O' ? 'Abierto' : 'Cerrado',
        ImportEnt: item.ImportEnt,
        sheet_distribution_state: hrState,
        TaxDate: moment(item.TaxDate).format('DD/MM/YYYY'),
        DocDueDate: moment(item.DocDueDate).format('DD/MM/YYYY'),
        backDay: moment().diff(moment(item.DocDueDate), 'days') + ' días',
        DiscPrcnt: item.DiscPrcnt,
        DocTotal: item.DocTotal,
        PaidToDate: item.PaidToDate,
        Saldo: item.Saldo,
        creditNotes: item.totalCN,
        totalPaid: parseFloat(item.totalPaid || 0).toFixed(2),
      };
    });
  }, [aviableDocuments]);

  function renderTotalPaidCell(cellValue) {
    let tooltipMsg = '';
    if (handlePay > 0) {
      if (handlePay > totalPay) {
        tooltipMsg = 'Agrega Doc.';
      } else if (handlePay == totalPay) {
        tooltipMsg = 'Completo';
      } else if (cellValue.value < totalPay - handlePay) {
        tooltipMsg = 'Desmarcar';
      } else {
        tooltipMsg = `= ${(cellValue.value - (totalPay - handlePay)).toFixed(2)}`;
      }
    }
    return (
      <div>
        {selectionModel.some((x) => x.DocEntry === cellValue.id) ? (
          <Tooltip title={tooltipMsg}>
            <IconButton aria-label="delete">
              <Dialpad fontSize="small" />
            </IconButton>
          </Tooltip>
        ) : undefined}
        {cellValue.value}
      </div>
    );
  }

  async function getDocuments(CardCode, CardType) {
    let response, creditNotesResponse;
    let queryParams = { CardCode };
    if (zoneId !== undefined) {
      queryParams.base_zone_id = zoneId;
    }
    setAviableDocuments([]);
    setLoading(true);
    if (CardType === 'C') {
      [response, creditNotesResponse] = await Promise.all([
        wsFindBy('sap/business-partner/receivable', queryParams),
        wsFindBy('sap/business-partner/credit-note', { CardCode, pendient: 1 }),
      ]);
    } else {
      [response, creditNotesResponse] = await Promise.all([
        wsFindBy('sap/provider/receivable', queryParams),
        wsFindBy('sap/provider/credit-note', { CardCode, pendient: 1 }),
      ]);
    }

    let creditNotes = [];
    if (creditNotesResponse !== undefined) {
      if (creditNotesResponse.success) {
        if (Array.isArray(creditNotesResponse.data)) {
          creditNotes = creditNotesResponse.data;
        }
      }
    }

    if (response.success === false) {
      showNotify('Error al recuperar los documentos del socio negocio', 'error');
      setLoading(false);
      return;
    }
    let newData = response.data.map((item) => {
      let mObject = {
        ...item,
        totalPaid: item.Saldo,
        creditNotes: [],
        totalCN: 0,
      };
      let filterCN = creditNotes.filter((cn) => {
        return (
          cn.U_SYP_MDSO === item.U_SYP_MDSD && // Serie
          cn.U_SYP_MDCO === item.U_SYP_MDCD && // Correlativo
          cn.U_SYP_MDTO === item.U_SYP_MDTD
        ); // Tipo documento
      });

      if (filterCN.length > 0) {
        mObject.creditNotes = filterCN;
        mObject.totalCN = filterCN.reduce(
          (reducer, cn) => reducer + (parseFloat(cn.DocTotal) - parseFloat(cn.PaidToDate)),
          0,
        );
        mObject.totalPaid -= mObject.totalCN;
      }

      return mObject;
    });
    if (creditNotes.length > 0) {
      for (let i = newData.length - 1; i >= 0; i--) {
        let documento = newData[i];
        if (documento.creditNotes.length > 0) {
          newData.splice(i + 1, 0, ...documento.creditNotes);
        }
      }
    }

    setAviableDocuments(newData);
    setLoading(false);
  }

  async function getDocumentsImport(importedData) {
    setAviableDocuments([]);
    setLoading(true);

    try {
      // Extraer todos los CardCodes únicos para las notas de crédito
      const uniqueCardCodes = [...new Set(importedData.map(item => item.CardCode))];
      
      // Hacer las peticiones en paralelo
      const [documentsResponse, ...creditNotesResponses] = await Promise.all([
        wsPost('sap/business-partner/receivable-documents', importedData),
        // Crear una petición de notas de crédito para cada CardCode único
        ...uniqueCardCodes.map(cardCode => 
          wsFindBy('sap/business-partner/credit-note', { CardCode: cardCode, pendient: 1 })
        )
      ]);

      if (!documentsResponse.success) {
        showNotify('Error al recuperar los documentos importados', 'error');
        setLoading(false);
        return [];
      }

      // Combinar todas las notas de crédito
      let allCreditNotes = [];
      creditNotesResponses.forEach(cnResponse => {
        if (cnResponse?.success && Array.isArray(cnResponse.data)) {
          allCreditNotes.push(...cnResponse.data);
        }
      });

      // Procesar los documentos igual que en la función original
      let processedDocuments = documentsResponse.data.map((item) => {
        let mObject = {
          ...item,
          totalPaid: item.Saldo,
          creditNotes: [],
          totalCN: 0,
        };

        // Filtrar notas de crédito relacionadas
        let filterCN = allCreditNotes.filter((cn) => {
          return (
            cn.U_SYP_MDSO === item.U_SYP_MDSD && // Serie
            cn.U_SYP_MDCO === item.U_SYP_MDCD && // Correlativo
            cn.U_SYP_MDTO === item.U_SYP_MDTD    // Tipo documento
          );
        });

        if (filterCN.length > 0) {
          mObject.creditNotes = filterCN;
          mObject.totalCN = filterCN.reduce(
            (reducer, cn) => reducer + (parseFloat(cn.DocTotal) - parseFloat(cn.PaidToDate)),
            0,
          );
          mObject.totalPaid -= mObject.totalCN;
        }

        return mObject;
      });

      // Insertar las notas de crédito en la lista igual que en la función original
      if (allCreditNotes.length > 0) {
        for (let i = processedDocuments.length - 1; i >= 0; i--) {
          let documento = processedDocuments[i];
          if (documento.creditNotes.length > 0) {
            processedDocuments.splice(i + 1, 0, ...documento.creditNotes);
          }
        }
      }

      setAviableDocuments(processedDocuments);
      setLoading(false);
      return processedDocuments;

    } catch (error) {
      console.error('Error en getDocumentsImport:', error);
      showNotify("Error al recuperar los documentos importados", "error");
      setLoading(false);
      return [];
    }
  }

  function generateId(document) {
    return `${document.ObjType}-${document.DocEntry}${
      document.ObjType == 14 ? `-${document.U_SYP_MDSO}|${document.U_SYP_MDCO}` : ''
    }`;
  }

  function calculation(selectedRowData) {
    let total = selectedRowData
      .filter((item) => !isNaN(item.totalPaid))
      .reduce((sum, item) => sum + parseFloat(parseFloat(item.totalPaid).toFixed(2)), 0);
    total = parseFloat(total.toFixed(6));
    if (total < 0) {
      total = 0;
    }
    setTotalPay(total); //setea suma de los valores seleccionados
  }

  function mergeData(ids) {
    let difference = ids.length - selectionIds.length;
    let addeds = [];
    let deleteds = [];
    if (difference > 0) {
      if (difference === 1) {
        addeds[0] = ids.find((item) => !selectionIds.includes(item));
      } else {
        addeds = ids.filter((item) => !selectionIds.includes(item));
      }
    } else {
      if (difference === -1) {
        deleteds[0] = selectionIds.find((item) => !ids.includes(item));
      } else {
        deleteds = selectionIds.filter((item) => !ids.includes(item));
      }
    }

    if (addeds.length > 0) {
      for (let documentId of addeds) {
        let data = documentId.split('-');
        if (data[0] === '13' || data[0] === '18') {
          let document = aviableDocuments.find((item) => item.DocEntry === data[1]);
          if (document.creditNotes?.length > 0) {
            ids = ids.concat(document.creditNotes.map((item) => generateId(item)));
          }
        }
      }
    }

    if (deleteds.length > 0) {
      for (let documentId of deleteds) {
        let data = documentId.split('-');
        if (data[0] === '13' || data[0] === '18') {
          let document = aviableDocuments.find((item) => item.DocEntry === data[1]);
          if (document.creditNotes?.length > 0) {
            for (let cnId of document.creditNotes.map((item) => generateId(item))) {
              let index = ids.indexOf(cnId);
              if (index !== -1) {
                ids.splice(index, 1);
              }
            }
          }
        }
      }
    }

    setSelectionIds(ids);
  }

  function editCell(e) {
    //actualizando la propiedad de pago.
    let objIndex = aviableDocuments.findIndex((obj) => `${obj.ObjType}-${obj.DocEntry}` == e.id);
    // documents[objIndex].totalPaid = parseFloat(e.props.value); // esta linea se usaba en una version pero luego desaparecio de la documentacion oficial
    let value = e.value;
    setAviableDocuments((docs) => {
      docs[objIndex].totalPaid = parseFloat(value);
      return docs;
    });
  }

  useEffect(() => {
    if (!isImportMode) return;
    async function loadDocs() {
      if (!importedData?.length) return;
      const docs = await getDocumentsImport(importedData);
      setAviableDocuments(docs);
    }
    loadDocs();

  }, [importedData, isImportMode]);

  useEffect(() => {
    if (isImportMode) return;
    if (businessPartner === undefined) return;
    getDocuments(businessPartner.CardCode, businessPartner.CardType);
  }, [businessPartner, zoneId]);

  useEffect(() => {
    setTotalAmount(totalPay);
    setDocuments(
      selectionModel.map((document) => {
        let data = {
          DocEntry: document.DocEntry,
          ObjType: document.ObjType,
          Sum: document.totalPaid < 0 ? 0 : document.totalPaid,
          TaxDate: document.TaxDate,
        };
        if (!!document.creditNotes) {
          data.CreditNotes = document.creditNotes.map((cn) => cn.DocEntry);
        }

        return data;
      }),
    );
  }, [totalPay, selectionModel]);

  return (
    <CardContainer icon={null} title="Documentos pendientes de pagos Recibidos:" style={{ height: '600px' }}>
      <DataGrid
        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
        checkboxSelection
        rowHeight={35}
        columns={dataGridColumns}
        selectionModel={selectionIds}
        onSelectionModelChange={(model) => {
          const selectedIDs = new Set(model);
          const selectedRowData = aviableDocuments.filter((row) =>
            selectedIDs.has(`${row.ObjType}-${row.DocEntry}`),
          );
          setSelectionModel(selectedRowData); //setea data seleccionada
          calculation(selectedRowData);
          mergeData(model);
        }}
        loading={loading}
        disableSelectionOnClick
        isRowSelectable={({ row }) => ![14, 19].includes(parseInt(row.ObjType))}
        rows={aviableDocumentsMapped}
        onCellEditCommit={(e) => {
          editCell(e);
          calculation(selectionModel);
        }}
      />
    </CardContainer>
  );
}

export default memo(PaymentDocuments);
